import ResultsTable from "./ResultsTable";
import { StyleTabs } from "./ResultsTabsStyles";
import { defaultHeaderCategories, headerOrder } from "../../utils/headers";
import { useState } from "react";
import { Tabs } from "@dealer-center/core-components";
import type { ResultsTabsProps } from "@dealer-center/ddc-pages-inventory-archiver-interface";
import DiffTable from "./DiffTable";

const ResultsTabs = ({ data }: ResultsTabsProps) => {
  const [checkedCategories, setCheckedCategories] = useState(
    defaultHeaderCategories
  );
  const onToggleHeaders = (checkedCategories: string[]) => {
    const newArr: string[] = [];
    headerOrder.forEach((key: string) => {
      if (checkedCategories.includes(key)) {
        newArr.push(key);
      }
    });
    setCheckedCategories(newArr);
  };

  return (
    <StyleTabs>
      {data && (
        <Tabs
          id="ResultsContainer"
          tabs={[
            {
              component: (
                <DiffTable
                  checkedCategories={checkedCategories}
                  data={data}
                  onToggleHeaders={onToggleHeaders}
                />
              ),
              label: "Diff Data",
              value: "diffData",
              disabled: !data?.preData && !data?.postData
            },
            {
              component: (
                <ResultsTable
                  checkedCategories={checkedCategories}
                  data={data?.preData || []}
                  onToggleHeaders={onToggleHeaders}
                />
              ),
              label: "Incoming Data",
              value: "preData",
              disabled: !data?.preData
            },
            {
              component: (
                <ResultsTable
                  checkedCategories={checkedCategories}
                  data={data?.postData || []}
                  onToggleHeaders={onToggleHeaders}
                />
              ),
              label: "Processed Data",
              value: "postData",
              disabled: !data?.postData
            }
          ]}
        />
      )}
    </StyleTabs>
  );
};

export default ResultsTabs;
